import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setAdminToken = (token) => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("benne_admin_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("benne_admin_token");
    }
};

const cached = localStorage.getItem("benne_admin_token");
if (cached) {
    api.defaults.headers.common["Authorization"] = `Bearer ${cached}`;
}

export const getPosts = (type, options = {}) => {
    const params = {};
    if (type) params.type = type;
    if (options.withinHours) params.within_hours = options.withinHours;
    if (options.category) params.category = options.category;
    if (options.excludeSlug) params.exclude_slug = options.excludeSlug;
    if (options.limit) params.limit = options.limit;
    return api.get("/posts", { params }).then((r) => r.data);
};
export const getPost = (slug) => api.get(`/posts/${slug}`).then((r) => r.data);
export const getEvents = (month) =>
    api.get("/events", { params: month ? { month } : {} }).then((r) => r.data);
export const subscribe = (payload) => {
    const body = typeof payload === "string" ? { email: payload } : payload;
    return api.post("/subscribe", body).then((r) => r.data);
};
export const sendContact = (payload) =>
    api.post("/contact", payload).then((r) => r.data);
export const searchPosts = (q) =>
    api.get("/search", { params: { q } }).then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const adminUpdateSettings = (payload) =>
    api.put("/admin/settings", payload).then((r) => r.data);

export const adminLogin = (password) =>
    api.post("/admin/login", { password }).then((r) => r.data);
export const adminCreatePost = (payload) =>
    api.post("/admin/posts", payload).then((r) => r.data);
export const adminUpdatePost = (id, payload) =>
    api.put(`/admin/posts/${id}`, payload).then((r) => r.data);
export const adminDeletePost = (id) =>
    api.delete(`/admin/posts/${id}`).then((r) => r.data);
export const adminBumpPost = (id) =>
    api.post(`/admin/posts/${id}/bump`).then((r) => r.data);

export const adminListSubmissions = (status) =>
    api
        .get("/admin/submissions", {
            params: status ? { status } : {},
        })
        .then((r) => r.data);
export const adminUpdateSubmissionStatus = (id, status, adminNote = "") =>
    api
        .patch(`/admin/submissions/${id}`, {
            status,
            admin_note: adminNote,
        })
        .then((r) => r.data);
export const adminEditSubmission = (id, fields) =>
    api.put(`/admin/submissions/${id}`, fields).then((r) => r.data);
export const adminGetSpamLog = () =>
    api.get("/admin/spam-log").then((r) => r.data);
export const adminDeleteSubmission = (id) =>
    api.delete(`/admin/submissions/${id}`).then((r) => r.data);
export const adminGetWebhookUrl = () =>
    api.get("/admin/webhook-url").then((r) => r.data);
export const adminCreateEvent = (payload) =>
    api.post("/admin/events", payload).then((r) => r.data);
export const adminUpdateEvent = (id, payload) =>
    api.put(`/admin/events/${id}`, payload).then((r) => r.data);
export const adminDeleteEvent = (id) =>
    api.delete(`/admin/events/${id}`).then((r) => r.data);
